<template>
  <div class="sonar-results-scoring__wrapper">
    <div class="sonar-results-scoring__message">
      <img
        v-if="showConfetti"
        class="sonar-results-scoring__confetti"
        src="../../assets/images/confetti.gif"
        alt="Confetti"
      />
      <h4 class="sonar-results-scoring__title">{{ titleLabel }}</h4>
      <h3 class="sonar-results-scoring__label">
        {{ resultLabel }}
      </h3>
    </div>
    <div class="sonar-results-scoring__info">
      <SonarSkillProgress
        v-for="skillArea in skillAreas"
        :key="skillArea.id"
        :skill="skillArea"
      />
      <div class="sonar-results-scoring__read-wrapper">
        <div class="sonar-results-scoring__read">
          <div class="sonar-results-scoring__read--difficulty">Novice</div>
        </div>
        <div class="sonar-results-scoring__read">
          <div class="sonar-results-scoring__read--difficulty">
            Professional
          </div>
        </div>
        <div class="sonar-results-scoring__read">
          <div class="sonar-results-scoring__read--difficulty">
            Advanced
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { andText } from '@/helpers/textTransform'
import SonarSkillProgress from '../SonarSkillProgress.vue'

export default {
  name: 'SonarResultsScoring',
  components: {
    SonarSkillProgress,
  },
  props: {
    currentScore: {
      type: Object,
      required: false,
    },
    lastAssessment: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showConfetti() {
      return !this.lastAssessment.is_retaken && this.lastAssessment.is_passed
    },
    skillAreasText() {
      const skill_areas = this.lastAssessment.score_per_skill_area.map(
        ska => ska.name
      )
      return andText(skill_areas)
    },
    titleLabel() {
      return !this.lastAssessment.is_retaken
        ? 'Assessment results'
        : 'Reassessment results'
    },
    resultLabel() {
      if (!this.lastAssessment.is_retaken && this.lastAssessment.is_passed) {
        return `Congratulations you leveled up in ${this.skillAreasText}!`
      }
      if (this.lastAssessment.is_retaken && this.lastAssessment.is_passed) {
        return `Congratulations on an outstanding performance!`
      }
      return `Nice effort! Keep training for better results!`
    },
    skillAreas() {
      return this.lastAssessment?.score_per_skill_area
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-results-scoring {
  &__wrapper {
    position: relative;
    display: flex;
    gap: 20px;
    border-radius: 30px 30px 0 0;
    padding: 30px 50px;
    min-height: 237px;
    background-image: url('../../assets/images/score-bg.png');
    background-repeat: no-repeat;
    background-position: -100px;
    background-size: 100%;
    overflow: hidden;
  }
  &__message {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 7px;
    flex: 1 0 303px;
  }
  &__confetti {
    left: -120px;
    top: -200px;
    position: absolute;
    filter: brightness(2);
  }
  &__title,
  &__label {
    font-family: var(--font-bold);
    margin: 0;
  }
  &__title {
    color: var(--white);
    font-size: rem(20);
    line-height: rem(26);
  }
  &__label {
    color: var(--ice-cold);
    font-size: rem(24);
    line-height: rem(32);
  }
  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 7px;
    flex: 0 1 100%;
  }
  &__read-wrapper {
    display: flex;
    gap: 4px;
    margin-top: 3px;
  }
  &__read {
    position: relative;
    width: 100%;
    height: 14px;
    border-left: 1px solid var(--perfect-gray);
    border-bottom: 1px solid var(--perfect-gray);
    border-right: 1px solid var(--perfect-gray);
    &--difficulty {
      position: absolute;
      bottom: -11px;
      left: 50%;
      transform: translateX(-50%);
      background: var(--charcoal);
      color: var(--white);
      padding: 0 5px;
      font-size: rem(14);
      line-height: rem(20);
      font-family: var(--font-bold);
    }
  }
}
</style>
